module.exports = __webpack_public_path__ + "img/person.1b2ab955.svg";